import { Button, Typography } from 'antd'
import { useSyncUsersMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import {
  simpleErrorNotification,
  simpleSuccessNotification,
} from 'hooks/notificationHandler'
import { useState } from 'react'

const UserSync: React.VFC = () => {
  const [sync] = useSyncUsersMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({ syncUsers: { success } }) => {
      if (success) return simpleSuccessNotification('User Sync successful')
      return simpleErrorNotification('User Sync unsuccessful')
    },
  })
  const [loading, setLoading] = useState(false)
  return (
    <>
      <Typography.Paragraph>
        Users are assigned to Projects though an Azure Entra ID User Group.
        These User Groups are associated with each Project. If a User is a
        member of a Project's User Group, they are a member of the Project.
      </Typography.Paragraph>
      <Typography.Paragraph>
        At the top of every hour, a Cron Job runs to pull down Users and User
        Groups from Entra ID in order to sync up our Users and User Groups
        database tables. This job only updates scalar properties of each user,
        and any groups they may be assigned to. Roles and Permissions can be
        managed in each project's Users page.
      </Typography.Paragraph>
      <Typography.Paragraph>
        Sometimes, a sync may need to be made on demand.
      </Typography.Paragraph>
      <Typography.Paragraph>
        This request will clear <Typography.Text underline>all</Typography.Text>{' '}
        users from the Redis Cache. If you think one or more users are missing
        certain permissions or properties that wouldn't be modified with a sync,
        try managing them in the Redis page first.
      </Typography.Paragraph>
      <Button
        type="primary"
        loading={loading}
        disabled={loading}
        onClick={async () => {
          setLoading(true)
          await sync()
          setLoading(false)
        }}
      >
        Request Sync
      </Button>
    </>
  )
}

export default UserSync
